import 'styles/cart/gallery-cart-summary.scss';

import React from 'react';

import propTypes from 'propTypes';
import PriceSpan from 'common/components/formatters/PriceSpan';

export default class GalleryCartSummary extends React.Component {
  static propTypes = {
    pendingPrice: propTypes.number.isRequired,
  };

  render() {
    const { pendingPrice } = this.props;
    return (
      <div className="GalleryCartSummary">
        <span className="GalleryCartSummary__price">
          <PriceSpan amount={pendingPrice} />
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/components/GalleryCartSummary.js